import { ROLES } from "../../../../utils/rolePermissions";

export function canDeleteCalendar(staffProfile) {
  const role = staffProfile?.role;
  const allowedRoles = new Set([ROLES.ADMIN]);

  return allowedRoles.has(role);
}
